import { call, put, takeLatest } from "redux-saga/effects";
import {
  ADD_SYSTEM_CONFIGURATION,
  GET_SYSTEM_CONFIGURATION,
  EDIT_SYSTEM_CONFIGURATION,
  UPLOAD_FILE,
  DOWNLOAD_FILE,
} from "./actionTypes";

import {
  addSystemConfiguration,
  getSystemConfiguration,
  editSystemConfiguration,
  uploadFile,
  downloadSystemConfigFile,
} from "../../../http/UAM/systemConfig.helper";
import { allSystemConfiguration } from "./action";
import { decryptedValue } from "common/utility";

function* addSystemConfigurations({ payload: { data, history } }) {
  const user = decryptedValue(localStorage.getItem("user"));
  try {
    const responseFromAPI = yield call(addSystemConfiguration, data);
    if (responseFromAPI.code == 201) {
      history(`/${user.roleName}/system-config`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* getSystemConfigurations({ payload: { data } }) {
  try {
    const responseFromAPI = yield call(getSystemConfiguration, data);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allSystemConfiguration({ data }));
    } else {
      yield put(allSystemConfiguration({ data: [] }));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* editSystemConfigurations({ payload: { data, history } }) {
  try {
    const responseFromAPI = yield call(editSystemConfiguration, data);
    if (responseFromAPI.code == 201) {
      history(`/${user.roleName}/system-config`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* uploadFiles({ payload: { data } }) {
  try {
    yield call(uploadFile, data);
  } catch (error) {
    console.log("error", error);
  }
}

function* downloadSystemConfigurationsFiles({ payload: { data } }) {
  try {
    const str = data.substring(data.indexOf("com") + 4);
    const filename = data.substring(data.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };
    const responseFromAPI = yield call(downloadSystemConfigFile, obj);
    if (responseFromAPI.code == 200) {
      const { result } = responseFromAPI;
      downloadFile(result, ext, filename);
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* SystemConfigurationSaga() {
  yield takeLatest(ADD_SYSTEM_CONFIGURATION, addSystemConfigurations);
  yield takeLatest(GET_SYSTEM_CONFIGURATION, getSystemConfigurations);
  yield takeLatest(EDIT_SYSTEM_CONFIGURATION, editSystemConfigurations);
  yield takeLatest(UPLOAD_FILE, uploadFiles);
  yield takeLatest(DOWNLOAD_FILE, downloadSystemConfigurationsFiles);
}

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  }
}

export default SystemConfigurationSaga;
